import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import { resetQueueGlobalCount } from 'ui/store/emarsys/action';
import { store } from 'ui/store';
import { PAGE_NAME_NEWS_TIPS_LIST } from '../../../constants/emarsys/news-tips-list';

const eventClickNewsList = (
  pageTitle: string,
  pageCategory: string,
  pageNumber: number,
  sectionName: string,
  buttonName: string,
  newsName?: string
) => {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isNewsActive = getFlagValue(FLAG_ENUM.EMARSYS_NEWS_LIST);
  if (!isFlagActive || !isNewsActive) return;
  const state = store.getState();
  const { userData } = state.auth || {
    userData: null,
  };
  if (userData?.customerNo) {
    ScarabQueue.push(['setCustomerId', userData?.customerNo]);
  }

  const valuePageView: Record<string, string | number | boolean> = {
    page_name: PAGE_NAME_NEWS_TIPS_LIST.BERITA_DAN_TIPS_LISTING_PAGE,
    page_title: pageTitle,
    page_url: window.location.href,
    page_category: pageCategory,
    page_number: pageNumber,
    section_name: sectionName,
    button_name: buttonName,
  };

  if (newsName) {
    valuePageView.news_name = newsName;
  }

  ScarabQueue.push(['tag', 'click_button', valuePageView]);

  ScarabQueue.push(['go']);
  store.dispatch(resetQueueGlobalCount());
};

export default eventClickNewsList;
